/**
 * Text Validation Utilities
 * Centralized input validation and sanitization
 */

import { InputSanitizer } from '@/utils/sanitization';
import { APP_CONFIG } from '@/constants';

export interface ValidationResult {
  isValid: boolean;
  error?: string;
  sanitized?: string;
}

/**
 * Validate and sanitize text input for analysis
 */
export const validateAnalysisText = (text: string): ValidationResult => {
  // Check if empty
  if (!text.trim()) {
    return {
      isValid: false,
      error: "Please enter some text to analyze"
    };
  }

  // Check length
  if (text.length > APP_CONFIG.maxTextLength) {
    return {
      isValid: false,
      error: `Text is too long. Please keep it under ${APP_CONFIG.maxTextLength} characters.`
    };
  }

  // Sanitize
  const sanitized = InputSanitizer.sanitizeText(text);
  
  // Check if sanitization removed everything
  if (sanitized.length === 0) {
    return {
      isValid: false,
      error: "Please enter valid text to analyze"
    };
  }

  return {
    isValid: true,
    sanitized
  };
};

/**
 * Check if text length is valid
 */
export const isValidTextLength = (text: string, maxLength: number = APP_CONFIG.maxTextLength): boolean => {
  return text.length <= maxLength;
};
